import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { parse } from 'querystring';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useEffect } from 'react';

export default function LoginRedirect(): JSX.Element {
  const { t } = useTranslation();
  const history = useCustomHistory();
  const location = useLocation();
  const qs = location.search.replace(/^[?]/gi, '');
  const { code } = parse(qs);

  useEffect(() => {
    if (code === 'SUCCESS') {
      alert(t('login/redirect/success_message'));
    } else {
      alert(t('login/redirect/invalid_code_message'));
    }
    history.push('/login');
  }, []);

  return <></>;
}
